import React, { useEffect, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'

const ensureRoot = () => {
  const id = 'mac-table-popovers'
  let el = document.getElementById(id)
  if (!el) {
    el = document.createElement('div')
    el.id = id
    el.style.position = 'fixed'
    el.style.left = '0'
    el.style.top = '0'
    el.style.width = '0'
    el.style.height = '0'
    el.style.zIndex = '999999'
    document.body.appendChild(el)
  }
  return el
}

export const useAnchorPosition = (rect: DOMRect | null, width: number, height: number, prefer: 'right' | 'left' = 'right') => {
  return useMemo(() => {
    if (!rect) return { left: 0, top: 0 }
    const vw = window.innerWidth
    const vh = window.innerHeight
    const pad = 10
    let left = prefer === 'right' ? rect.right - width : rect.left
    let top = rect.bottom + 8
    if (left + width > vw - pad) left = vw - pad - width
    if (left < pad) left = pad
    if (top + height > vh - pad) top = Math.max(pad, rect.top - 8 - height)
    if (top < pad) top = pad
    return { left: Math.round(left), top: Math.round(top) }
  }, [rect?.left, rect?.top, rect?.right, rect?.bottom, width, height, prefer])
}

export const PopoverPortal = ({ children }: any) => {
  const [root, setRoot] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setRoot(ensureRoot())
  }, [])

  if (!root) return null
  return createPortal(children, root)
}
